import Vue from "vue";
import VueRouter from "vue-router";

import Mgr from "@/services/SsoService";
import Etab from "@/components/etablissement/Etab";
//import Siret from "@/components/freeSearch/Siret";
import Home from "@/components/home/home";
import Fiche from "@/components/home/fiche";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/siret/:siret",
    component: Etab,
    props: true,
    beforeEnter: requireAuth,
  },
     {
    path: "/search/:search/active/:active",
    component: Fiche,
    beforeEnter: requireAuth,
  },
  {
    path: "/find",
    component: Fiche,
    beforeEnter: requireAuth,
  },
  {
    path: "/search/:search",
    component: Fiche,
    props: true,
    beforeEnter: requireAuth,
  },

  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function requireAuth(from, to, next) {
  var requireAuthConfig  =  (process.env.APP_REQUIRE_AUTH || "True") == "True"
  requireAuthConfig = false
  if (!requireAuthConfig) {
    return  next();
  }
  sessionStorage.setItem("from", from.path);
  var user = new Mgr();
  user.getSignedIn().then((signIn) => {
    if (signIn) {
      return next();
    }
  });
}

export default router;
